import { Progress, Label } from '@apia/theme';

export interface IProgressBar {
  id: string;
  progress?: number;
  loading?: boolean;
}

const ProgressBar = ({
  id,
  progress = 0,
  loading = false,
}: IProgressBar): JSX.Element => {
  return (
    <>
      <Label
        htmlFor={id}
        sx={{
          display: loading ? 'block' : 'none',
          m: '0px',
        }}
      >
        {`${progress}%`}
      </Label>
      <Progress
        id={id}
        max={100}
        value={progress}
        {...window.getVariant('styles.progress')}
        sx={{
          display: loading ? 'block' : 'none',
        }}
      >
        {`${progress}%`}
      </Progress>
    </>
  );
};

export default ProgressBar;
